(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alvori-how-it-works"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alvori-how-slider')) {
    customElements.define('alvori-how-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const track = this.querySelector('[data-how-track]');
        const controls = this.querySelector('[data-how-controls]');
        const previous = this.querySelector('[data-how-prev]');
        const next = this.querySelector('[data-how-next]');
        if (!track || !controls || !previous || !next) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const updateControls = () => {
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll - 2;
        };
        const move = direction => {
          const card = track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
        };
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', updateControls, { passive: true, signal });
        this.resizeObserver = new ResizeObserver(updateControls);
        this.resizeObserver.observe(track);
        controls.hidden = false;
        this.frame = requestAnimationFrame(updateControls);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
